export class storeCompareController {
    allbrand: any;
    ShowDifrentClass: boolean;
    toggleDifrent: () => void;
    ShowDifrent: () => void;
    NumOfProducts: any;
    compareDifrent: any;
    compareOrginal: any;
    compare: any;
    productTypeId: any;
    item5: any;
    item4: any;
    item3: any;
    item2: any;
    item1: any;
    noItemCount: any[];
    url: any;
    AjaxLoading: boolean;
    BaseUrlPage: any;
    constructor(private $rootScope, private $timeout, private $http, private $window, private $location, private localStorageService, private $mPath, private ProductCompareService, private $state, private MyConstant) {
        "ngInject"

        $mPath.get().then(response => {
            this.BaseUrlPage = response;
        })
        $rootScope.$on('$routeChangeSuccess', () => {
            this.$onInit()
        })

    }
    $onInit() {
        this.AjaxLoading = true;
        this.url = this.$location.path().split('/');
        //  for (i=1;i<this.url.length;i++) {
        // 	this.classname ="c" + i
        // }
        var noItemCount = 5 - (this.url.length - 1);
        this.noItemCount = [];
        for (i = 0; i < noItemCount; i++) {
            this.noItemCount.push({})
        }
        for (var i = 1; i < this.url.length; i++) {
            this['item' + i] = this.url[i];
        };

        if (this.url.length - 1 == 1) {

            var query = `${this.MyConstant.ApiUrl}ECBTempGeneral/GetProductsToCompare/?ProductIDs=${this.item1}`;
        }
        if (this.url.length - 1 == 2) {

            var query = `${this.MyConstant.ApiUrl}ECBTempGeneral/GetProductsToCompare/?ProductIDs=${this.item1}&ProductIDs=${this.item2}`;
        }
        if (this.url.length - 1 == 3) {

            var query = `${this.MyConstant.ApiUrl}ECBTempGeneral/GetProductsToCompare/?ProductIDs=${this.item1}&ProductIDs=${this.item2}&ProductIDs=${this.item3}`;
        }
        if (this.url.length - 1 == 4) {

            var query = `${this.MyConstant.ApiUrl}ECBTempGeneral/GetProductsToCompare/?ProductIDs=${this.item1}&ProductIDs=${this.item2}&ProductIDs=${this.item3}&ProductIDs=${this.item4}`;
        }
        if (this.url.length - 1 == 5) {

            var query = `${this.MyConstant.ApiUrl}ECBTempGeneral/GetProductsToCompare/?ProductIDs=${this.item1}&ProductIDs=${this.item2}&ProductIDs=${this.item3}&ProductIDs=${this.item4}&ProductIDs=${this.item5}`;
        } else if (this.url.length - 1 == 0) {

            this.$window.location.href = '/';
        }


        this.$http.get(query)
            .then(res => {
                this.AjaxLoading = false;
                this.compare = res.data.AttributeDefGroups;
                this.productTypeId = res.data.Products[0].ProductTypeID
                this.ProductCompareService.GetAllBrand(this.productTypeId)
                    .then((res) => {
                        this.allbrand = res.data
                    });

                this.compareOrginal = angular.copy(this.compare);
                this.compareDifrent = angular.copy(this.compare);
                // 
                // 
                this.NumOfProducts = res.data.Products;
                this.$rootScope.NumOfProducts = res.data.Products;

            })
            .then(() => {

                // this.$watch(function(){return $window.innerWidth;}, function() {
                //        var a = document.getElementById("compare").offsetWidth;
                // 	this.widthOfCol = (a-235)/this.NumOfProducts.length;
                // 	
                //  		});
                /**
                 * @description jahate hazf satrhaE ke hameye sotonhaye an moshabeh hastand
                 */
                this.ShowDifrent = () => {

                    var compareDifrent = angular.copy(this.compareOrginal)


                    var array = {};
                    angular.forEach(this.compareOrginal, (key4, val4) => {
                        var deletecount = 0;
                        angular.forEach(key4.AttributeDefComparables, (key3, val3) => {
                            array[key3.DefID] = {}
                            angular.forEach(key3.ComparableValues, (key2, val2) => {

                                array[key3.DefID][val2] = {}
                                angular.forEach(key2.Values, (key, val) => {

                                    array[key3.DefID][val2][val] = key;


                                    if (val2 == this.NumOfProducts.length - 1) {
                                        //akharin sotun ro check mikone
                                        var keepGoing2 = true;

                                        for (var j = this.NumOfProducts.length - 1; j > 0; j--) {



                                            if (keepGoing2) {

                                                if (Object.size(array[key3.DefID][j]) == Object.size(array[key3.DefID][j - 1])) {
                                                    var keepGoing = true;
                                                    for (var i = 0; i < Object.size(array[key3.DefID][j]); i++) {

                                                        if (keepGoing) {
                                                            if (array[key3.DefID][j][i] == array[key3.DefID][j - 1][i]) {



                                                                //agar keepGoing true bud edame bede


                                                                if (i == Object.size(array[key3.DefID][j]) - 1 && j == 1) {

                                                                    //agar akharin item check shavande bud

                                                                    this.compareDifrent[val4].AttributeDefComparables.splice(val3 - deletecount, 1);
                                                                    deletecount++;


                                                                    //satri ke moshabeh bashe ra hazf mikone
                                                                }

                                                            } else {

                                                                keepGoing = false;
                                                                keepGoing2 = false;
                                                                //dar surate peida kardane yek tafavot keepGoing ra false mikone 
                                                            }

                                                        }
                                                    };

                                                } else {

                                                    keepGoing2 = false;

                                                }
                                            }
                                        };

                                    }

                                })
                            })
                        })
                    })

                }
                this.toggleDifrent = () => {
                    if (this.ShowDifrentClass == true) {
                        this.ShowDifrentClass = false;
                        this.compare = null;

                        this.compare = angular.copy(this.compareOrginal);
                    } else {

                        this.ShowDifrentClass = true;
                        this.compare = null;

                        this.compare = angular.copy(this.compareDifrent)
                    }

                }
                Object.size = function (obj) {
                    var size = 0,
                        key;
                    for (key in obj) {
                        if (obj.hasOwnProperty(key)) size++;
                    }
                    return size;
                };
                this.ShowDifrent();

                // var a = document.getElementById("compare").offsetWidth;
                // this.widthOfCol = (a - 235) / $rootScope.NumOfProducts.length;

            })
    }
    setBrand(brand, noItem) {
        noItem.nameOfBrand = brand.Name;
        noItem.BrandID = brand.ManufacturerID;
        this.ProductCompareService.GetAllProduct(this.productTypeId, brand.ManufacturerID)
            .then(function (res) {
                noItem.allproduct = res.data;
            })
    }


    setProduct(product, noItem) {
        noItem.nameOfProduct = product.ProductName;
        noItem.productID = product.ProductID;
    }

    checkExist(product) {
        var exist = false;
        angular.forEach(this.url, function (val, key) {
            if (product == val) {
                exist = true;
            }
        })
        if (exist) {
            return false
        } else {
            return true
        }

    }

    AddToCompare(ProductID) {
        var currentUrl = this.$location.path() + '/' + ProductID
        this.$location.path(currentUrl)
        this.$onInit();

    }

    removeCompare(item) {
        var index = this.url.indexOf(item.ProductID.toString());
        this.url.splice(index, 1);
        var url = '';
        for (var i = 1; i < this.url.length; i++) {
            url = url + '/' + this.url[i]
        };
        if (url == '') {
            this.$window.location.href = '/';
        } else {

            this.$location.path(url)
        }

        this.localStorageService.remove(item.ProductID);
        this.$onInit();

    }
}




// WEBPACK FOOTER //
// ./src/components/store-compare/store-compare.controller.ts